export const getFontClassName = (fontWeight, language) => {
    if (fontWeight === 'bold') {
        if (language === 'ar') {
            return 'TanseekModernProArabicBold modal-title'
        } else if (language === 'cn') {
            return 'NotoSansTC-Bold'
        } else {
            return 'kia-bold modal-title'
        }
    } else if (fontWeight === 'medium') {
        if (language === 'ar') {
            return 'TanseekModernProArabicRegular'
        } else if (language === 'cn') {
            return 'NotoSansTC-Medium'
        } else {
            return 'kia-medium'
        }
    } else if (fontWeight === 'light') {
        if (language === 'ar') {
            return 'TanseekModernProArabicLight'
        } else if (language === 'cn') {
            return 'NotoSansTC-Light'
        } else {
            return 'kia-light'
        }
    }
}

export const getFontSize = (fontSize, language) => {
    if (language === 'ar') {
        return Math.round(fontSize * 1.4)
    } else {
        return fontSize
    }
}

export const getRegularFontSize = (windowWidth, language) => {
    if (windowWidth > 1024) {
        return getFontSize(16, language)
    } else if (windowWidth >= 840) {
        return getFontSize(24, language)
    } else {
        return getFontSize(12, language)
    }
}

export const getMediumFontSize = (windowWidth, language) => {
    if (windowWidth > 1024) {
        return getFontSize(20, language)
    } else if (windowWidth >= 840) {
        return getFontSize(24, language)
    } else {
        return getFontSize(16, language)
    }
} 

export const getLargeFontSize = (windowWidth, language) => {
    if (windowWidth > 1024) {
        return getFontSize(21, language)
    } else if (windowWidth >= 840) {
        return getFontSize(25, language)
    } else {
        return getFontSize(18, language)
    }
} 

export const getClickHereFontSize = (circleWidth, language) => {
    return getFontSize(circleWidth / 210.6 * 25, language)
}

export const getExLargeFontSize = (windowWidth, language) => {
    if (windowWidth > 1024) {
        return getFontSize(26, language)
    } else if (windowWidth >= 840) {
        return getFontSize(36, language)
    } else {
        return getFontSize(24, language)
    }
} 

export const getBrandFontSize = (windowWidth, language) => {
    if (windowWidth > 1024) {
        return getFontSize(30, language)
    } else if (windowWidth >= 840) {
        return getFontSize(34, language)
    } else {
        return getFontSize(20, language)
    }
}

export const getSpecMenuTitleFontSize = (windowWidth, language) => {
    if (windowWidth > 1024) {
        return getExLargeFontSize(windowWidth, language)
    } else if (windowWidth >= 840) {
        return getFontSize(26, language)
    } else {
        return getFontSize(16, language)
    }
}

export const getButtonIconSize = (windowWidth) => {
    if (windowWidth > 1024) {
        return 60
    } else if (windowWidth >= 840) {
        return 96
    } else {
        return 40
    }
}

export const getSpecificationWidth = (windowWidth, windowHeight) => {
    if (windowWidth > 1080) {
        return Math.min(540, windowWidth / 2)
    } else {
        if (windowWidth > windowHeight) {
            return windowWidth / 2
        } else {
            return  windowWidth
        }
    }
}
